import { useEffect, useRef, useState } from 'react';

import { PredefinedMilisecondsTypeEnum } from '../lib/enums';

/**
 * Copies text to the clipboard and keeps a short-lived "copied" flag for a confirmation toast.
 */
const useCopiedToast = (duration: number = PredefinedMilisecondsTypeEnum.twoSeconds) => {
  const [isCopied, setIsCopied] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => () => {
    if (timerRef.current) clearTimeout(timerRef.current);
  }, []);

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (error) {
      console.error('[useCopiedToast] Unable to copy to the clipboard', error);

      return;
    }

    if (timerRef.current) clearTimeout(timerRef.current);
    setIsCopied(true);
    timerRef.current = setTimeout(() => setIsCopied(false), duration);
  };

  return { isCopied, copyToClipboard };
};

export default useCopiedToast;
